module.exports = __webpack_public_path__ + "img/Semi-logo-SERMAS-15x15-mm5-200x200.f79f523a.jpg";